import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WorkspaceService as WorkspaceDataService } from '@app/shared/store/data-services';
import { UpdateWorkspaceDto, Workspace } from '@app/shared/store/entities';
import { WorkspaceSelectors } from '@app/shared/store/selectors';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { KpConfirmDialogComponent } from '@keeps-platform-frontend-workspace/ui/kp-confirm-dialog';
import { Store } from '@ngrx/store';
import { WorkspacesService } from 'app/shared/services';
import { Observable, filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-workspace-info',
  standalone: false,
  template: `
    <app-workspace-form
      [workspace]="workspace$ | async"
      (deleted)="onDelete($event)"
      (updated)="onUpdate($event)"
    ></app-workspace-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceInfoComponent {
  id: string;
  workspace$: Observable<Partial<Workspace>>;

  constructor(
    private _workspacesService: WorkspacesService,
    private _router: Router,
    private store: Store,
    private _dialog: MatDialog,
    private _workspaceDataService: WorkspaceDataService,
    private _workspaceService: WorkspaceService,
  ) {
    this.id = this._workspaceService.getCurrentWorkspace().id;
    this.workspace$ = this.store.select(WorkspaceSelectors.selectCurrentWorkspace(this.id));
  }

  onUpdate(workspace: UpdateWorkspaceDto) {
    this._workspaceDataService.update(workspace).subscribe((workspace) => {
      this._workspaceService.setCurrentWorkspace({ ...workspace } as unknown);
    });
  }

  onDelete(workspaceId: string): void {
    const dialogRef = this._dialog.open(KpConfirmDialogComponent);
    dialogRef.componentInstance.confirmTitle = marker('WORKSPACE_PROFILE.WARNING');
    dialogRef.componentInstance.confirmMessage = marker('WORKSPACE_PROFILE.CONFIRM_DELETE_THIS_WORKSPACE');

    dialogRef
      .afterClosed()
      .pipe(
        filter((result) => !!result),
        switchMap(() => this._workspaceDataService.delete(workspaceId)),
      )
      .subscribe(() => {
        this._workspacesService.removeCurrentWorkspace();
        this._router.navigate(['/', 'workspaces']);
      });
  }
}
